/**
 * ISO datetimes without a timezone suffix are treated as local by JS, which skews
 * relative time vs UTC in Postgres. If there is no offset or Z, interpret as UTC.
 */
export function parseServerInstantMs(dateStr: string): number {
  const raw = dateStr.trim();
  const normalized = raw.includes("T")
    ? raw
    : raw.replace(/^(\d{4}-\d{2}-\d{2})[ T](.*)$/, "$1T$2");
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    return new Date(normalized).getTime();
  }
  return new Date(`${normalized}Z`).getTime();
}

export function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - parseServerInstantMs(dateStr);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min${mins > 1 ? "s" : ""} ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "Yesterday";
  return `${days} days ago`;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatTableDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
